export const fallbackServices = [
  {
    id: "1",
    title: { da: "Havedesign & Nyanlæg" },
    description: { da: "<p>Drømmer du om en helt ny have eller omlægning af den eksisterende? Vi hjælper dig med alt fra idé til færdigt resultat. Vi skaber smukke bede, planter træer og buske, og etablerer flotte grønne græsplæner, der passer perfekt til det vestjyske klima.</p>" },
    image: ["https://assets.auxodev.dk/assets/7ce43b4c-cc9c-4d7d-8d95-aa06e798843e/4817d1f4-a80f-4dbe-aca5-664c58aee383.jpg"],
    icon_name: "Sprout"
  },
  {
    id: "2",
    title: { da: "Belægning & Flisearbejde" },
    description: { da: "<p>Vi lægger solide og smukke fliser til indkørsler, terrasser, gangstier og støttemure. Med fokus på præcision og holdbarhed sikrer vi, at din belægning holder i mange år, uanset vind og vejr i Midt- og Vestjylland.</p>" },
    image: ["https://assets.auxodev.dk/assets/7ce43b4c-cc9c-4d7d-8d95-aa06e798843e/4ff0ce2b-412b-4fcd-80b3-c9745925ecdf.jpg"],
    icon_name: "Grid"
  },
  {
    id: "3",
    title: { da: "Havepleje & Vedligeholdelse" },
    description: { da: "<p>Lad os stå for det grove arbejde, så du kan nyde din have. Vi tilbyder professionel hækkeklipning, græsslåning, beskæring af buske og træer samt ukrudtsbekæmpelse. Vi kører ud til både private husejere og sommerhuse i hele Midt- og Vestjylland.</p>" },
    image: ["https://assets.auxodev.dk/assets/7ce43b4c-cc9c-4d7d-8d95-aa06e798843e/c8bcef9a-11a3-4edc-8fee-07b19d27e5ee.jpg"],
    icon_name: "Scissors"
  }
];

export const fallbackTestimonials = [
  {
    id: "1",
    name: "Mads & Lene Thomsen",
    location: "Thisted",
    text: { da: "<p>Vi fik lagt ny fliseterrasse og omlagt vores forhave af Anlægsgartneren fra Thy. Resultatet er blevet helt fantastisk! Han overholdt alle aftaler, arbejdede utrolig effektivt og prisen var yderst rimelig. Kan varmt anbefales!</p>" },
    rating: 5
  },
  {
    id: "2",
    name: "Kirsten Jensen",
    location: "Hurup Thy",
    text: { da: "<p>Super professionel hækkeklipning og havepleje. Min have har aldrig set så flot ud før. Det er en stor lettelse at have en pålidelig gartner, man altid kan regne med. Fem stjerner herfra!</p>" },
    rating: 5
  },
  {
    id: "3",
    name: "Henrik Poulsen",
    location: "Klitmøller",
    text: { da: "<p>Fik etableret ny græsplæne ved vores sommerhus. Selvom jorden var sandet og udfordrende, lykkedes det ham at skabe en tæt og flot grøn plæne. Rigtig god service og rådgivning undervejs.</p>" },
    rating: 5
  }
];

export const aboutData = {
  name: "Lasse Poulsen",
  title: "Mød Lasse: Gartneren fra Thy",
  image: "https://assets.auxodev.dk/assets/7ce43b4c-cc9c-4d7d-8d95-aa06e798843e/5a380c33-c297-4e16-b3cd-5a01f4d1485b.jpg",
  bio: [
    "Mit navn er Lasse, og det er mig, du møder i arbejdstøjet, når du ringer til BP Anlægsgartner. Jeg er født og opvokset i Thy, og selvom jeg i dag kører ud fra min base i Vestjylland mellem Herning og Holstebro, har jeg taget den nordvestjyske mentalitet med mig: Et ord er et ord, vi taler i øjenhøjde, og arbejdet bliver gjort ordentligt første gang.",
    "Med en uddannelse som skov- og naturassistent og mange års erfaring fra anlægsgartnerbranchen, har jeg fingrene dybt plantet i den jyske muld. Jeg har startet BP Anlægsgartner, fordi jeg brænder for at skabe mærkbare resultater i tæt samarbejde med dig.",
    "For mig er en opgave ikke bare noget, der skal overstås – jeg sætter en ære i, at vi sammen finder den helt rigtige løsning, uanset om haven skal shines op, eller indkørslen skal lægges om. Hvad enten du drømmer om en snorlige hækkeklipning, professionel naturpleje eller en flot, ny belægning, går jeg til opgaven med masser af gåpåmod og et smil på læben.",
    "Skal vi tage en uforpligtende snak om dit næste haveprojekt?"
  ],
  values: [
    {
      title: "Lokal forankring",
      description: "Jeg kender Midt- og Vestjylland ud og ind – fra de sandede jorde ved vestkysten til den lerede muld i indlandet."
    },
    {
      title: "Pålidelighed",
      description: "En aftale er en aftale. Jeg kommer til tiden, rydder op efter mig selv og afleverer et fejlfrit resultat."
    },
    {
      title: "Høj kvalitet",
      description: "Jeg går ikke på kompromis med materialer eller udførelse. Din have skal holde sig smuk i mange år."
    }
  ]
};

export const contactInfo = {
  phone: "+45 22 33 44 55",
  email: "kontakt@gartnerenthy.dk",
  address: "Klitmøllervej 124, 7700 Thisted",
  cvr: "44556677",
  hours: [
    { days: "Mandag - Fredag", time: "07:00 - 17:00" },
    { days: "Lørdag", time: "08:00 - 13:00" },
    { days: "Søndag", time: "Lukket" }
  ]
};
